<div class="productWrap backgroundPage" fxLayout="column" id="{{ 'p_' + cartProduct.product_id }}">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <a mat-raised-button color="primary" (click)="onAddCartNav(cartProduct)" class="addCartButt">
                <mat-icon class="cartIcon">add_shopping_cart</mat-icon>
                {{ 'general.addToCart' | transloco }}
            </a>
            @if (cartProduct.inAmazon) {
                <div>
                    <a mat-raised-button color="primary" (click)="onBuyAtAmazon($event)" class="addCartButt addCartButtAmazon">
                        <fa-icon [icon]="faAmazon"></fa-icon>
                        <span class="addCartButtAmazonText">Buy on Amazon</span>
                    </a>
                </div>
            }
        </div>
        <br class="hide-gt-sm"/>
        <mat-label class="productHeader">
            <span class="bolder2">{{ cartProduct.description }}</span>
        </mat-label>
        <mat-label class="productPrice productHeader bolder2" style="margin-left: 20px;">
            <span class="bolder">{{ cartProduct.price | StringJSV2Pipe:stringJSPipeArgs }}<span class="pennies">.00</span></span>
        </mat-label>
    </div>

    @if (cartProduct.inAmazon && onSaleActive) {
        <div fxFlex="100%" fxLayout="column">
            <div class="specialOffer">
                <p class="writeUpHeadline">Special offer, Save $270.00. Buy one & get one FREE</p>
                <h5 class="shaking">New orders only, limited time. must place order on or before {{ onSaleEnd }}</h5>
                <ol>
                    <li>Place your first order for a mediaDROID+ on the Amazon store</li>
                    <li>Wait to receive the mediaDROID+ in the mail from Amazon.com</li>
                    <li>If you LOVE 💗💗💗 it, write a review and rate it on the Amazon store</li>
                    <li>Contact us via live chat with your order id and share your positive review</li>
                    <li>Will mail you an extra mediaDROID+ for FREE as we appreciate your support</li>
                </ol>
            </div>
        </div>
    }

    <div fxFlex="100%" fxLayout="row" style="gap: 10%;" class="flex-lt-md-col-reverse">
        <div fxFlex="100%">
            <mat-label class="writeUp">
                {{ cartProduct.long_description }}
            </mat-label>
        </div>
        <div fxFlex="285px">
            <br/>
            <br/>
            <img (click)="onImageSelected(cartProduct)" src="{{productImages}}{{cartProduct.image}}" class="mainImage"/>
        </div>
    </div>
    <div fxFlex="100%" fxLayout="column">
        <div>
            <br/>
            <br/>
            <ul>
                @for (bullet of cartProduct.bullets.split('| '); track bullet) {
                    <li class="bullets">
                        {{ bullet }}
                    </li>
                }
            </ul>
            <br/>
            <br/>
        </div>
        <div fxLayout="row wrap">
            <img (click)="onThumbSelected(cartProduct,1)" class="thumb" src="{{productImages}}{{cartProduct.image_thumb_1}}"/>
            <img (click)="onThumbSelected(cartProduct,2)" class="thumb" src="{{productImages}}{{cartProduct.image_thumb_2}}"/>
            <img (click)="onThumbSelected(cartProduct,3)" class="thumb" src="{{productImages}}{{cartProduct.image_thumb_3}}"/>
            @if (cartProduct.product_id == ADZ) {
                <img (click)="onThumbSelected(cartProduct,4)" class="thumb" src="{{productImages}}{{cartProduct.image_thumb_4}}"/>
            }
            @if (cartProduct.product_id == ADZ) {
                <img (click)="onThumbSelected(cartProduct,5)" class="thumb" src="{{productImages}}{{cartProduct.image_thumb_5}}"/>
            }
            @if (cartProduct.product_id == ADZ) {
                <img (click)="onThumbSelected(cartProduct,6)" class="thumb" src="{{productImages}}{{cartProduct.image_thumb_6}}"/>
            }
            @if (cartProduct.product_id == ADZ) {
                <img (click)="onThumbSelected(cartProduct,7)" class="thumb" src="{{productImages}}{{cartProduct.image_thumb_7}}"/>
            }
            @if (cartProduct.product_id == ADZ) {
                <img (click)="onThumbSelected(cartProduct,8)" class="thumb" src="{{productImages}}{{cartProduct.image_thumb_8}}"/>
            }
        </div>
    </div>
</div>
<ng-template let-modal #thumbDialogModal>
    <div mat-dialog-content>
        <div class="helper-image">
            <img class="mainImageDialog" alt="" src="{{productImages}}{{selectedThumb}}"/>
        </div>
    </div>
</ng-template>

